// Browser-side resize + re-encode (drops EXIF/GPS). Used because Workers have no image library.
const encode = (canvas, quality) =>
  new Promise((resolve) => {
    canvas.toBlob((webp) => {
      if (webp && webp.type === "image/webp") return resolve(webp);
      canvas.toBlob((jpg) => resolve(jpg), "image/jpeg", quality);
    }, "image/webp", quality);
  });

export const resizeImage = async (file, maxSide, quality = 0.85) => {
  const bmp = await createImageBitmap(file);
  const scale = Math.min(1, maxSide / Math.max(bmp.width, bmp.height));
  const canvas = document.createElement("canvas");
  canvas.width = Math.round(bmp.width * scale);
  canvas.height = Math.round(bmp.height * scale);
  const ctx = canvas.getContext("2d");
  ctx.fillStyle = "#ffffff";
  ctx.fillRect(0, 0, canvas.width, canvas.height);
  ctx.drawImage(bmp, 0, 0, canvas.width, canvas.height);
  bmp.close?.();
  return encode(canvas, quality);
};
